import React from 'react';
import '../styles/Hero.css';

function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Hi, I'm <span className="highlight">Floyd Cheng</span></h1>
            <h2 className="subtitle">Full-Stack Front-End Developer</h2>
            <p className="hero-description">
              I create beautiful, responsive, and user-friendly web applications 
              using modern technologies like React, JavaScript, and CSS. 
              Passionate about clean code and exceptional user experiences.
            </p>
            <div className="hero-buttons">
              <a 
                href="https://fcheng.io/baccarat/" 
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                View My Work
              </a>
              <button 
                className="btn btn-secondary"
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              >
                Get In Touch
              </button>
            </div>
          </div>
          <div className="hero-image">
            <div className="placeholder-avatar">
              <div className="avatar-circle">
                <span>YN</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;